import { paperClasses } from "@mui/material/Paper";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCard = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				borderRadius: "20px",
				// `palette.mode` is fixed at build time in CSS-variables mode, so the dark card
				// never got its own elevation - it was outlined with a dark hairline against a
				// dark ground and read as flat.
				[`&.${paperClasses.elevation1}`]: {
					boxShadow: "0 5px 22px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.06)",
					...theme.applyStyles("dark", {
						boxShadow: "0 5px 22px 0 rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(255, 255, 255, 0.12)",
					}),
				},
			};
		},
	},
} satisfies Components<Theme>["MuiCard"];
